import axios from 'axios';
import Endpoints from '../Endpoints';

// Update a user's wallet balance
// payload: { userId: string, type: 'ev' | 'trp', amount: number, reason?: string }
export const updateWalletBalance = async (payload) => {
  const { data } = await axios.put(Endpoints.Wallet.BALANCE, payload, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('USER_TOKEN')}`,
    },
  });
  return data;
};

export const getAdminUserWallet = async (userId) => {
  const { data } = await axios.get(`${Endpoints.Wallet.ADMIN_USER}${userId}`, {
    headers: { Authorization: `Bearer ${localStorage.getItem('USER_TOKEN')}` },
  });
  return data?.data;
};
